<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="dialog-content">
    <div class="header">
        <div class="dialog-title" matDialogTitle>
            <h4>{{ 'eula.title.update' | translate }}</h4>
            <button matDialogClose windeClose>
                <sui-svg-icon icon="cross"/>
            </button>
        </div>
    </div>
    <div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="content preloader-wrapper">
        @if (eula$ | async; as eula) {
            <h5>{{ 'eula.info.title' | translate }}</h5>
            <div class="grid">
                <div class="grid-row">
                    <div class="grid-row__cell">{{ 'eula.info.name' | translate }}</div>
                    <div class="grid-row__cell">
                        <a [href]="downloadUrl">{{ eula.fileName }}</a>
                    </div>
                </div>
                <div class="grid-row">
                    <div class="grid-row__cell">{{ 'eula.info.date' | translate }}</div>
                    <div class="grid-row__cell">{{ eula.versionDate | date: 'MMM d, y, h:mm:ss a' }}</div>
                </div>
            </div>
        }
        <h5>{{ 'eula.info.uploadNew' | translate }}</h5>
        <label class="custom-file custom-file--uploader">
            <input
                #fileInput
                (change)="selectFile($event)"
                (click)="fileInput.value = null"
                accept=".doc, .docx, .pdf"
                class="custom-file-input"
                placeholder="Upload file"
                type="file"
            />
            <span class="custom-file-label">
                {{ selectedFile ? selectedFile.name : ('eula.info.uploadNew' | translate) }}
            </span>
            <small class="form-text text-muted">{{ 'eula.info.supportedFiles' | translate }}</small>
        </label>
    </div>
    <div class="footer">
        <div class="footer-actions">
            <button matDialogClose windeTransparent>
                <sui-svg-icon icon="cross"/>
                {{ 'entity.action.cancel' | translate }}
            </button>
            <button (click)="uploadEula()" [disabled]="!selectedFile" windeGreen>
                <sui-svg-icon icon="save"/>
                {{ 'entity.action.save' | translate }}
            </button>
        </div>
    </div>
</div>
